import aboutBg from "../assets/images/aboutUsBackGraound.png";
import projectsBg from "../assets/images/OurProjects.png";
import servicesBg from "../assets/images/Services.jpg";
import contactBg from "../assets/images/CountactUs.png";

export const PAGE_HEROES = {
  about: {
    backgroundImage: aboutBg,
    blendClass: "style-blend-mode",
    titleKey: "About Us",
    subtitleKey:
      "We are CAF SPORTS One of the leading companies in Egypt and United Arab Emirates specialized in the field of sports construction and Artificial flooring.",
  },
  projects: {
    backgroundImage: projectsBg,
    blendClass: "style-blend-mode",
    titleKey: "Our Projects",
    subtitleKey:
      "Discover Versatile Solutions Tailored to Meet Your Every Need",
  },
  products: {
    backgroundImage: servicesBg,
    blendClass: "style-blend-mode",
    titleKey: "Products",
    subtitleKey:
      "Explore our premium sports flooring products designed for superior performance, safety, and durability.",
  },
  cart: {
    backgroundImage: servicesBg,
    blendClass: "style-blend-mode",
    titleKey: "Shopping Cart",
    subtitleKey: "Review your selected products before checkout.",
  },
  checkout: {
    backgroundImage: contactBg,
    blendClass: "style-blend-mode-contact",
    titleKey: "Checkout",
    subtitleKey: "Complete your billing details to place your order.",
  },
  orderSuccess: {
    backgroundImage: projectsBg,
    blendClass: "style-blend-mode",
    titleKey: "Order Success",
    subtitleKey: "Your order has been received successfully.",
  },
  services: {
    backgroundImage: servicesBg,
    blendClass: "style-blend-mode",
    titleKey: "Our Services",
    subtitleKey:
      "Our products conform to standard specifications and are suitable for changing weather conditions",
  },
  contact: {
    backgroundImage: contactBg,
    blendClass: "style-blend-mode-contact",
    titleKey: "Contact Us",
    subtitleKey:
      "Always at your service and the goal is to always satisfy our customers",
  },
};
